import type { AgentApiJobSourcesService } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

// 旧 HERP（AGENT_URL・「エージェント向けのURLをお持ちの方」）は herp_agent に統合したため新規追加の選択肢からは除外する
const HIDDEN_SOURCE_TYPES: string[] = ['herp'];

export default function useFetchJobSourcesServices() {
  return useQuery({
    queryKey: ['jobSourcesServices'],
    queryFn: async () => {
      const response = await fetch(`/agent/api/job_sources/services.json`);
      const data: AgentApiJobSourcesService[] = await response.json();

      return data.filter((service) => !HIDDEN_SOURCE_TYPES.includes(service.source_type));
    },
  });
}
